import * as angular from "angular";
import {IController} from "angular";
import {QuantitySettingType} from "../../types/quantitySetting.type";
import {PriceType} from "../../types/price.type";

export class QuantitySettingsTableRowCtrl implements IController {

  priceType: PriceType;
  quantitySetting: any;
  onAmountChange: Function;
  onChange: Function;
  onRemove: Function;

  public quantitySettingTypeOptions: QuantitySettingType[];
  public currencySymbol: any;

  /* @ngInject */
  constructor(private splitService, private quantitySettingConstants) {
    this.currencySymbol = this.splitService.getCurrencySymbol();
    this.quantitySettingTypeOptions = this.quantitySettingConstants.types;
  }

  $onInit() {

  }

  getQuantityTypeChargeSymbol() {
    let symbol;
    switch(this.quantitySetting.type) {
      case QuantitySettingType.SurchargePercentage: {
        symbol = '%';
        break;
      }
      case QuantitySettingType.DiscountPercentage: {
        symbol = '%';
        break;
      }
      default: {
        symbol = this.currencySymbol;
        break;
      }
    }
    return symbol;
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('quantitySettingsTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      priceType: '<',
      quantitySetting: '<',
      onAmountChange: '&',
      onChange: '&',
      onRemove: '&'
    },
    template: require('./quantity-settings-table-row.html').default,
    controller: QuantitySettingsTableRowCtrl
  });
